import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

function SubscriptionAlertBox({ title, subject }) {
  return (
    <div id="subscription-alert-box">
      <h5>{title}</h5>
      <p>{subject}</p>

      <Button variant='info'>Unlock Feature</Button>
    </div>
  );
}

SubscriptionAlertBox.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SubscriptionAlertBox;
